import { render } from "./VaPageNotFoundSearch.vue?vue&type=template&id=71853852"
import script from "./VaPageNotFoundSearch.vue?vue&type=script&lang=js"
export * from "./VaPageNotFoundSearch.vue?vue&type=script&lang=js"

import "./VaPageNotFoundSearch.vue?vue&type=style&index=0&id=71853852&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__